import { appendFiles, appendLocation, buildEncryptedDocumentUrl, fetchEncryptedImage } from "@/api/helpers";
const baseURL = `${process.env.VUE_APP_SERVER_URL}/Ouvidoria`;

export async function ObterProtocolos({ vinculo, classificacao }) {
  return await globalThis.window.$axios
    .get({
      url: `${baseURL}/ObterProtocolos`,
      query: {
        vinculo,
        idClassifica: classificacao
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("ObterProtocolos", error.message);
      return error;
    });
}
export async function DetalheProtocolo({ vinculo, protocolo, classificacao }) {
  return await globalThis.window.$axios
    .get({
      url: `${baseURL}/DetalheProtocolo`,
      query: {
        vinculo,
        protocolo,
        idClassifica: classificacao
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("DetalheProtocolo", error.message);
      return error;
    });
}

export async function VerificarProtocoloReclamacao({ vinculo, protocolo }) {
  return await globalThis.window.$axios
    .get({
      url: `${baseURL}/VerificarProtocoloReclamacao`,
      query: {
        vinculo,
        protocolo
      }
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("VerificarProtocoloReclamacao", error.message);
      return error;
    });
}

export async function SolicitarOuvidoria({ vinculo, protocolo, assunto, observacao, anexosN }) {
  const data = new FormData();
  data.append("protocolo", protocolo);
  data.append("assunto", assunto);
  data.append("observacao", observacao);

  appendFiles(data, anexosN);
  await appendLocation(data);

  return globalThis.window.$axios
    .post({
      url: `${baseURL}/SolicitarOuvidoria`,
      query: {
        vinculo
      },
      contentType: "multipart/form-data",
      data
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("SolicitarOuvidoria", error.message);
      return error;
    });
}

export function ObterDocumento({ vinculo, protocolo }) {
  return buildEncryptedDocumentUrl(baseURL, { vinculo, protocolo });
}

export async function ObterImagem({ vinculo, documento, original }) {
  return await fetchEncryptedImage(baseURL, { vinculo, documento, original });
}

export async function RetornoPendencia({ vinculo, protocolo, observacao, arquivos, classificacao }) {
  const data = new FormData();
  data.append("protocolo", protocolo);
  data.append("observacao", observacao);
  appendFiles(data, arquivos);

  return globalThis.window.$axios
    .post({
      url: `${baseURL}/RetornoPendencia`,
      query: {
        vinculo,
        idClassifica: classificacao
      },
      contentType: "multipart/form-data",
      data
    })
    .then(resp => resp.data)
    .catch(error => {
      globalThis.window.$log.error("RetornoPendencia", error.message);
      return error;
    });
}
